<template>
  <div class="mmf">
    <div
      ref="inner"
      class="mmf__inner"
      :style="innerStyle"
    >
      <header class="mmf__header">
        <h2 class="mmf__title">
FILTER SEARCH
</h2>
        <a
          class="mmf__clear cursor-pointer"
          @click="clearFilters"
        >Clear Filter</a>
      </header>

      <div class="mmf__scrollwrap">
        <div
          ref="grid"
          class="mmf__grid"
        >
        <!-- Column 1: Brand (+ sub-brands) and Department -->
        <div class="mmf__col-wrap">
        <div
          class="mmf__col"
          data-col-index="0"
          @scroll="onColScroll"
        >
          <section
            v-if="filtersData?.brand?.length"
            class="mmf__group"
          >
            <h6 class="sub-title text-uppercase">
Brand
</h6>
            <template v-for="brand in filtersData?.brand">
              <div
                :key="'brand-' + brand.id"
                class="p-checkbox form-check d-flex align-items-center"
              >
                <input
                  :id="'mmf-brand-' + brand.id"
                  v-model="params.brand"
                  type="checkbox"
                  class="form-check-input"
                  :value="brand.id"
                >
                <label
                  :for="'mmf-brand-' + brand.id"
                  class="form-check-label ms-2 mt-1"
                >{{ brand.name }}</label>
              </div>
              <div
                v-if="brand.sub_brands && brand.sub_brands.length > 0"
                :key="'brand-subs-' + brand.id"
                class="mmf__subs"
              >
                <div
                  v-for="subBrand in brand.sub_brands"
                  :key="'sub-' + subBrand.id"
                  class="p-checkbox form-check d-flex align-items-center"
                >
                  <input
                    :id="'mmf-sub-' + subBrand.id"
                    v-model="params.sub_brand"
                    type="checkbox"
                    class="form-check-input"
                    :value="subBrand.id"
                  >
                  <label
                    :for="'mmf-sub-' + subBrand.id"
                    class="form-check-label ms-2 mt-1"
                  >{{ subBrand.name }}</label>
                </div>
              </div>
            </template>
          </section>

          <section
            v-if="filtersData?.department?.length"
            class="mmf__group"
          >
            <h6 class="sub-title text-uppercase">
Department
</h6>
            <div
              v-for="department in filtersData?.department"
              :key="'dept-' + department.id"
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'mmf-dept-' + department.id"
                v-model="params.department"
                type="checkbox"
                class="form-check-input"
                :value="department.id"
              >
              <label
                :for="'mmf-dept-' + department.id"
                class="form-check-label ms-2 mt-1"
              >{{ department.name }}</label>
            </div>
          </section>
        </div>
        <div
          v-show="colFade[0]"
          class="mmf__col-fade"
        />
        </div>

        <!-- Column 2: Category -->
        <div class="mmf__col-wrap">
        <div
          class="mmf__col"
          data-col-index="1"
          @scroll="onColScroll"
        >
          <section
            v-if="filtersData?.category?.length"
            class="mmf__group"
          >
            <h6 class="sub-title text-uppercase">
Category
</h6>
            <div
              v-for="category in filtersData?.category"
              :key="'cat-' + category.id"
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'mmf-cat-' + category.id"
                v-model="params.category"
                type="checkbox"
                class="form-check-input"
                :value="category.id"
              >
              <label
                :for="'mmf-cat-' + category.id"
                class="form-check-label ms-2 mt-1"
              >{{ category.name }}</label>
            </div>
          </section>
        </div>
        <div
          v-show="colFade[1]"
          class="mmf__col-fade"
        />
        </div>

        <!-- Column 3: Season and Color -->
        <div class="mmf__col-wrap">
        <div
          class="mmf__col"
          data-col-index="2"
          @scroll="onColScroll"
        >
          <section
            v-if="filtersData?.season?.length"
            class="mmf__group"
          >
            <h6 class="sub-title text-uppercase">
Season
</h6>
            <div
              v-for="season in filtersData?.season"
              :key="'season-' + season.id"
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'mmf-season-' + season.id"
                v-model="params.season"
                type="checkbox"
                class="form-check-input"
                :value="season.id"
              >
              <label
                :for="'mmf-season-' + season.id"
                class="form-check-label ms-2 mt-1"
              >{{ season.name }}</label>
            </div>
          </section>

          <section
            v-if="filtersData?.color?.length"
            class="mmf__group"
          >
            <h6 class="sub-title text-uppercase">
Color
</h6>
            <div
              v-for="color in filtersData?.color"
              :key="'color-' + color.id"
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'mmf-color-' + color.id"
                v-model="params.color"
                type="checkbox"
                class="form-check-input"
                :value="color.id"
              >
              <label
                :for="'mmf-color-' + color.id"
                class="form-check-label ms-2 mt-1"
              >{{ color.name }}</label>
            </div>
          </section>

          <!-- ≤1279px: fold Pattern / Availability / Inventory into column 3. -->
          <template v-if="isNarrow">
            <section
              v-if="filtersData?.pattern?.length"
              class="mmf__group"
            >
              <h6 class="sub-title text-uppercase">
Pattern
</h6>
              <div
                v-for="pattern in filtersData?.pattern"
                :key="'pattern-' + pattern.id"
                class="p-checkbox form-check d-flex align-items-center"
              >
                <input
                  :id="'mmf-pattern-' + pattern.id"
                  v-model="params.pattern"
                  type="checkbox"
                  class="form-check-input"
                  :value="pattern.id"
                >
                <label
                  :for="'mmf-pattern-' + pattern.id"
                  class="form-check-label ms-2 mt-1"
                >{{ pattern.name }}</label>
              </div>
            </section>

            <section
              v-if="filtersData?.availability?.length"
              class="mmf__group"
            >
              <h6 class="sub-title text-uppercase">
Availability
</h6>
              <div
                v-for="availability in filtersData?.availability"
                :key="'avail-' + availability.id"
                class="p-checkbox form-check d-flex align-items-center"
              >
                <input
                  :id="'mmf-avail-' + availability.id"
                  v-model="params.availability"
                  type="checkbox"
                  class="form-check-input"
                  :value="availability.id"
                >
                <label
                  :for="'mmf-avail-' + availability.id"
                  class="form-check-label ms-2 mt-1"
                >{{ availability.name }}</label>
              </div>
            </section>

            <section class="mmf__group">
              <inventory-criteria-quantity-input
                :quantity="params.quantity ? params.quantity.toString() : ''"
                :criteria="params.criteria"
                @inventoryDropdownChange="onIcqiInventoryDropdownChange"
                @inventoryInputBlurred="onIcqiInventoryInputBlurred"
              />
            </section>
          </template>
        </div>
        <div
          v-show="colFade[2]"
          class="mmf__col-fade"
        />
        </div>

        <!-- Column 4: Pattern, Availability, Inventory (only when >1279px). -->
        <div
          v-if="!isNarrow"
          class="mmf__col-wrap"
        >
        <div
          class="mmf__col"
          data-col-index="3"
          @scroll="onColScroll"
        >
          <section
            v-if="filtersData?.pattern?.length"
            class="mmf__group"
          >
            <h6 class="sub-title text-uppercase">
Pattern
</h6>
            <div
              v-for="pattern in filtersData?.pattern"
              :key="'pattern-' + pattern.id"
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'mmf-pattern-' + pattern.id"
                v-model="params.pattern"
                type="checkbox"
                class="form-check-input"
                :value="pattern.id"
              >
              <label
                :for="'mmf-pattern-' + pattern.id"
                class="form-check-label ms-2 mt-1"
              >{{ pattern.name }}</label>
            </div>
          </section>

          <section
            v-if="filtersData?.availability?.length"
            class="mmf__group"
          >
            <h6 class="sub-title text-uppercase">
Availability
</h6>
            <div
              v-for="availability in filtersData?.availability"
              :key="'avail-' + availability.id"
              class="p-checkbox form-check d-flex align-items-center"
            >
              <input
                :id="'mmf-avail-' + availability.id"
                v-model="params.availability"
                type="checkbox"
                class="form-check-input"
                :value="availability.id"
              >
              <label
                :for="'mmf-avail-' + availability.id"
                class="form-check-label ms-2 mt-1"
              >{{ availability.name }}</label>
            </div>
          </section>

          <section class="mmf__group">
            <inventory-criteria-quantity-input
              :quantity="params.quantity ? params.quantity.toString() : ''"
              :criteria="params.criteria"
              @inventoryDropdownChange="onIcqiInventoryDropdownChange"
              @inventoryInputBlurred="onIcqiInventoryInputBlurred"
            />
          </section>
        </div>
        <div
          v-show="colFade[3]"
          class="mmf__col-fade"
        />
        </div>
        </div>
      </div>

      <footer class="mmf__footer">
        <button
          type="button"
          class="mmf__apply"
          @click="applyFilters"
        >
APPLY
</button>
        <a
          class="mmf__cancel cursor-pointer"
          @click="$emit('cancel')"
        >Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { isEmpty } from 'lodash'
import InventoryCriteriaQuantityInput from '~/components/common/InventoryCriteriaQuantityInput'
import productFilterParams from '~/mixins/productFilterParams'
import { createScrollLock } from '~/helpers/scroll-lock'

/**
 * The XD "FILTER SEARCH" full-width panel for the new mega menu.
 *
 * All selection logic (params model, brand<->sub-brand sync, $route hydration,
 * apply-to-products navigation, clear) is inherited from productFilterParams —
 * the same mixin the legacy FilterSection dropdown uses — so behaviour is
 * identical and there is a single source of truth. This component contributes
 * only the XD layout.
 *
 * Applying emits `applied`; Cancel emits `cancel`. The host (DynamicTopMenu)
 * owns open/close and remounts the panel each time, so cancelling discards the
 * unsaved selection and reopening reflects only the applied URL filters.
 */
export default {
  name: 'MegaMenuFilterPanel',

  components: { InventoryCriteriaQuantityInput },

  mixins: [productFilterParams],

  data () {
    return {
      // Caps the panel to the viewport so long filter lists scroll inside each
      // column instead of pushing the Apply/Cancel row off-screen. Set from the
      // panel's distance to the viewport top.
      maxHeight: null,
      // Measured height of the scrollable panel body. Top-row columns clamp to
      // this so long lists scroll per-column instead of stretching to content.
      // Exposed to CSS via --mmf-body-h so wrapped rows below can still grow
      // naturally and be reached by scrolling the panel body.
      bodyHeight: null,
      // ≤1279px: the 4th column is folded into the 3rd column instead of
      // rendering as its own track, so Pattern / Availability / Inventory
      // sit under Season + Color and scroll as one column.
      isNarrow: false,
      // Per-column bottom fade — shown while that column has more content below
      // the visible scroll position. Replaces the hidden native scrollbar.
      colFade: [false, false, false, false]
    }
  },

  computed: {
    innerStyle () {
      const style = {}
      if (this.maxHeight) style.maxHeight = this.maxHeight
      if (this.bodyHeight) style['--mmf-body-h'] = this.bodyHeight
      return style
    }
  },

  watch: {
    filtersData () {
      // Options arrive after mount; recompute body height + fades once columns
      // have content (a wrapped 4th row appears at ≤1279px).
      this.$nextTick(this.updateSizes)
    }
  },

  created () {
    this._scrollLock = createScrollLock()
    // The mega menu loads its own payload; the shared filter options come from
    // the common menu, which may not have been fetched yet on this route.
    if (isEmpty(this.filtersData)) {
      this.fetchCommonMenu()
    }
  },

  mounted () {
    this.$nextTick(this.updateSizes)
    window.addEventListener('resize', this.updateSizes)
    this.lockBodyScroll()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.updateSizes)
    this.unlockBodyScroll()
  },

  methods: {
    ...mapActions({
      fetchCommonMenu: 'menus/fetchCommonMenu'
    }),

    updateSizes () {
      this.isNarrow = window.innerWidth <= 1279
      this.updateMaxHeight()
      // Two ticks: max-height must apply, then layout settles before the scroll
      // wrapper's visible height (used to clamp top-row columns) is measured.
      this.$nextTick(() => {
        this.updateBodyHeight()
        this.$nextTick(this.updateFades)
      })
    },

    updateMaxHeight () {
      const el = this.$refs.inner
      if (!el) return
      const top = el.getBoundingClientRect().top
      // Leave a small gap below the panel; never collapse below a usable height.
      this.maxHeight = Math.max(240, window.innerHeight - top - 16) + 'px'
    },

    updateBodyHeight () {
      const sw = this.$refs.grid?.parentElement
      if (!sw) return
      this.bodyHeight = sw.clientHeight + 'px'
    },

    onColScroll (event) {
      const idx = Number(event.currentTarget.dataset.colIndex)
      if (Number.isNaN(idx)) return
      this.setColFade(idx, event.currentTarget)
    },

    updateFades () {
      const cols = this.$refs.grid?.querySelectorAll('.mmf__col')
      if (!cols) return
      cols.forEach(el => {
        const idx = Number(el.dataset.colIndex)
        if (!Number.isNaN(idx)) this.setColFade(idx, el)
      })
    },

    setColFade (idx, el) {
      // Fade only while there is more content below the current scroll position.
      this.$set(this.colFade, idx, el.scrollTop + el.clientHeight < el.scrollHeight - 2)
    },

    lockBodyScroll () {
      // Keep the page from scrolling behind the panel so there is a single scroll
      // region (the filter grid), not a second page scrollbar.
      this._scrollLock.lock()
    },

    unlockBodyScroll () {
      this._scrollLock.unlock()
    }
  }
}
</script>

<style scoped lang="scss">
.mmf {
  background-color: #ffffff;
  border-bottom: 1px solid #e3e2e2;
}

.mmf__inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 28px 40px 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.mmf__header {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
  flex-shrink: 0;
}

.mmf__title {
  font: normal normal 500 18px/22px PlayfairDisplay-Medium, Georgia, serif;
  color: #383838;
  text-align: center;
  margin: 0;
}

.mmf__clear {
  font: normal normal normal 12px/14px Arial, Helvetica, sans-serif;
  color: #31b4d6;
  text-decoration: none;
}

.mmf__scrollwrap {
  position: relative;
  /* Panel-body scroll fallback; each column also owns its own scroll region.
     Scrollbar hidden to keep the panel clean. */
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.mmf__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: min-content;
  gap: 24px;

  @media (max-width: 1279px) {
    grid-template-columns: repeat(3, 1fr);
  }
}

.mmf__col-wrap {
  position: relative;
  min-height: 0;
  display: flex;
  /* All columns share the measured panel-body height so long lists scroll
     per-column instead of stretching the panel. At ≤1279px the 4th column's
     sections fold into column 3 (rendered by the template), so no wrapping
     row is needed. */
  height: var(--mmf-body-h, 100%);
}


.mmf__col {
  /* Independent scroll per column when content exceeds the panel-body height.
     Native scrollbar hidden; the bottom fade signals more content is below. */
  flex: 1 1 auto;
  min-height: 0;
  max-height: var(--mmf-body-h, 100%);
  overflow-y: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.mmf__col-fade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 48px;
  pointer-events: none;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
}

.mmf__group {
  margin-bottom: 22px;
}

.mmf__subs {
  padding-left: 10px;
}

.sub-title {
  font: normal normal bold 14px/16px Arial, Helvetica, sans-serif;
  color: #383838;
  text-align: left;
  margin-bottom: 9px;
}

.p-checkbox {
  margin-bottom: 15px;

  .form-check-input {
    width: 20px;
    height: 20px;
    min-width: 20px;
    border-radius: 0;
    border: 1px solid #383838;

    &:checked,
    &:indeterminate {
      background-color: #383838;
      border-color: #383838;
    }
  }

  .form-check-label {
    font: normal normal normal 14px/16px Arial, Helvetica, sans-serif;
    letter-spacing: 0;
    color: #898989;
    white-space: normal;
    text-align: left;
  }

  label,
  input {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

.mmf__footer {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 12px;
  padding-top: 16px;
  flex-shrink: 0;
  /* White-to-transparent gradient fading up from the footer, matching the
   * per-column bottom fade — hints that columns behind can still scroll. */
  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%;
    height: 48px;
    pointer-events: none;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
  }
}

.mmf__apply {
  min-width: 172px;
  padding: 12px 22px;
  background: #383838;
  color: #ffffff;
  border: 1px solid #383838;
  font: normal normal normal 13px/16px Arial, Helvetica, sans-serif;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: #000000;
  }
}

.mmf__cancel {
  font: normal normal normal 12px/14px Arial, Helvetica, sans-serif;
  color: #31b4d6;
  text-decoration: none;
}
</style>
